import React, { useEffect, useState } from "react";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import SubStep4 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep4";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import useEmpMapSubmission from "./useEmpMapSubmission";
import DocumentSection from "../PurchasableFAR/DocumentSection";
import RecommendationRemarksComponent from "../RecommendationComponent";
import { innerInspRecommendation, siteInspRecommendation } from "../../citizen/TCPForms/data";
import DetailInfoTable from "../AllViewRemarks";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import BasicSiteInspectionReport from "../ScheduleInspection/basicSiteInspectionReport";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Button } from "@mui/material";
import NewsTicker from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/TCP-HP/NewsTicker";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import DrawingsDetailsTable from "../AllViewRemarks/DrawingsTable";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";
import DscLetters from "../DigitalSignLetters";
import EmpIdentifyNoc from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpIdentifyNoc";
import PurchasableFARInfo from "../ReusableComponets/PurchasableInfo";
import CompoundingChecklist from "@egovernments/digit-ui-module-common/src/sharedComponents/CompoundingChecklist";
import PfarRemarks from "../RecommendationComponent/PfarRemarks";
import PfarDetailsTable from "../AllViewRemarks/PfarDetailsTable";
import SubStep1 from "../../citizen/AVPForms/formComponents/purchasableFARv3/Step1/SubStep1";
import SubStep3 from "../../citizen/AVPForms/formComponents/purchasableFARv3/Step1/SubStep3";
import SubStep2 from "../../citizen/AVPForms/formComponents/purchasableFARv3/Step1/SubStep2";
import Step4 from "../../citizen/AVPForms/formComponents/purchasableFARv3/Step4";

const EmpMapPurchasablePortal = ({ formData, refetch, submitAction, workflowDetails, userRolesArray, urlFormType }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [selectedNocTab, setSelectedNocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray?.[0]?.code);
  const [uploadedFile, setUploadedFile] = useState(null);
  const isJE = userRolesArray?.[0]?.code === "JE";
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    developerNocRemarks,
    setDeveloperNocRemarks,
    dataNocRecommendation,
    setDataNocRecommendation,
    dataRecommendation,
    nocRemarksData,
    callNocDetailsAPI,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callPfarDetailsAPI,
    callNotingDetailsAPI,
    siteDrawingRemarksData,
    pFarDetailsData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    handleNoWorkflowPFAR,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    isValidEmp,
    isPurchasbleReq,
    currentFormData,
    handleNoWorkflowCompounding,
    handleGetSiteInspectionById,
    callDocumentDetailsAPI,
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray, urlFormType);
  // const isHideAction = ["REVERT_TO_APPLICANT", "APPROVED"]?.includes(formData?.status) && !isCitizen;
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    // { label: "NOC Status" },
    // { label: "Fees" },
  ];
  const subTabDocLabels = [{ label: "Mandatory Documents" }, { label: "Conditional Documents" }];
  const subTabNocLabels = [{ label: "NOC Status" }, { label: "Select NOC" }];
  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
    // setDeveloperRemarks(documentRemarksData?.DetailDataRemarks?.[0]?.documentDetails?.developerRemarks);
  }, []);
  const handleTabChange = async (nextTabNo) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab) => {
    setSelectedDocTab(nextSubTab);
  };
  const handleSubNocTabChange = (nextSubTab) => {
    setSelectedNocTab(nextSubTab);
  };
  const isCompounding = params?.natureOfConstruction === "Compounding";

  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);

    if (isCompounding) {
      // Render Compounding Checklist tab only
      if (activeTab === 2) {
        return (
          <CompoundingChecklist
            formData={params}
            handleTabChange={handleTabChange}
            role="EMPLOYEE"
            handleNoWorkflowCompounding={handleNoWorkflowCompounding}
          />
        );
      }
      // Optionally, you can restrict other tabs or show a message if needed
      return null;
    }

    // Normal flow (existing logic)
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return <SubStep1 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 1:
          return <SubStep2 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 2:
          return <SubStep3 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 3:
          return <SubStep4 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        // case 4:
        //   return <Step5 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return (
            <React.Fragment>
              <div className="view-doc-container">
                <Button
                  variant="contained"
                  className="view-doc-btn"
                  onClick={handleDocView}
                  style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
                >
                  <span className="view-doc-icon">
                    <ViewSidebarIcon />
                  </span>
                  {currentView === "documents" ? "View all documents" : "View document section"}
                </Button>
              </div>
              {currentView === "documents" ? (
                <React.Fragment>
                  <DocumentSection
                    formData={params}
                    handleChange={handleTabChange}
                    setUpdatedDocuments={setUpdatedDocuments}
                    updatedDocuments={updatedDocuments}
                    setIsPreviewLoading={setIsPreviewLoading}
                    setDataRecommendation={setDataRecommendationDocument}
                    onSelect={onSelect}
                    handleNoWorkflow={handleNoWorkflow}
                    attachedDocs={params?.documents}
                    docType="mandatory"
                    detailData={documentRemarksData?.DetailDataRemarks}
                    developerRemarks={developerRemarksDocument}
                    callDocumentDetailsAPI={callDocumentDetailsAPI}
                    setError={setError}
                    ComposableComponent={(props) => (
                      <RecommendationRemarksComponent
                        title="Remarks Details"
                        label="Recommendation"
                        name="recommendation"
                        options={SortingAlphabatically(siteInspRecommendation)}
                        defaultValue={dataRecommendationDocument}
                        extraLabel="Remarks"
                        setDeveloperRemarks={setDeveloperRemarksDocument}
                        developerRemarks={
                          developerRemarksDocument
                            ? developerNocRemarks
                            : Array.isArray(documentRemarksData?.DetailDataRemarks) && documentRemarksData.DetailDataRemarks.length > 0
                            ? documentRemarksData?.DetailDataRemarks?.[documentRemarksData.DetailDataRemarks.length - 1]?.documentDetails
                                ?.developerRemarks
                            : documentRemarksData?.DetailDataRemarks?.documentDetails?.developerRemarks
                        }
                        setDataRecommendation={setDataRecommendationDocument}
                        {...props}
                        error={error}
                        setError={setError}
                      />
                    )}
                  />
                  {!isCitizen && <DetailInfoTable detailData={documentRemarksData?.DetailDataRemarks} type="documentDetails" />}
                </React.Fragment>
              ) : (
                <ViewDocuments
                  documentSection={documentSection}
                  setIsPreviewLoading={setIsPreviewLoading}
                  iframeSrc={iframeSrc}
                  setIframeSrc={setIframeSrc}
                  initialUrl={initialUrl}
                />
              )}
            </React.Fragment>
          );
        case 1:
          return (
            <React.Fragment>
              <DocumentSection
                formData={params}
                handleChange={handleTabChange}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={formData?.documents}
                setIsPreviewLoading={setIsPreviewLoading}
                setDataRecommendation={setDataRecommendationDocument}
                onSelect={onSelect}
                handleNoWorkflow={handleNoWorkflow}
                attachedDocs={params?.documents || formData?.documents}
                docType="conditional"
                callDocumentDetailsAPI={callDrawingDetailsAPI}
              />
            </React.Fragment>
          );
        default:
          return null;
      }
    } else if (activeTab === 2) {
      return (
        <EmpIdentifyNoc
          formData={params}
          tenantId={tenantId}
          handleNoWorkflowNoc={handleNoWorkflowNoc}
          isJE={isJE}
          currentFormData={currentFormData}
        />
      );
    } else if (activeTab === 3) {
      return (
        <React.Fragment>
          <Step4 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />
          {/* {!isCitizen && (
            <React.Fragment>
              <RecommendationRemarksComponent
                title="Recommendation Details"
                label="Recommendation"
                name="recommendation" // just a field name, not value!
                options={SortingAlphabatically(siteInspRecommendation)}
                optionsInner={innerInspRecommendation}
                defaultValue={dataRecommendation}
                extraLabel="Remarks"
                setDeveloperRemarks={setDeveloperRemarks}
                developerRemarks={developerRemarks}
                setDataRecommendation={setDataRecommendation}
                setSelectedObjection={setSelectedObjection}
                names="multiSelectField"
                type="drawingDetails"
                buttonshow={true}
                onSaveClick={callDrawingDetailsAPI} // <-- parent callback
              />
              <DrawingsDetailsTable detailData={siteDrawingRemarksData?.DetailDataRemarks} />
            </React.Fragment>
          )} */}
        </React.Fragment>
      );
    } else if (activeTab === 4) {
      return (
        <React.Fragment>
          <BasicSiteInspectionReport
            formData={params}
            setCurrentTab={handleTabChange}
            setUpdatedInspectionReportData={setUpdatedInspectionReportData}
            callInspectionDetailsAPI={callInspectionDetailsAPI}
            userRolesArray={userRolesArray}
            onSelect={onSelect}
          />
          <DetailInfoTable detailData={siteInspectionRemarksData?.DetailDataRemarks} type="inspectionDetails" formData={formData} />
        </React.Fragment>
      );
    } else if (activeTab === 5) {
      return (
        <React.Fragment>
          <PurchasableFARInfo
            formData={params}
            handleTabChange={handleTabChange}
            isEmployee={!isCitizen}
            handleNoWorkflowPFAR={handleNoWorkflowPFAR}
            isJE={isJE}
            handleGetSiteInspectionById={handleGetSiteInspectionById}
            workflowHistory={workflowDetails?.data}
            setRemarks={setRemarks}
            remarks={remarks}
            setError={setError}
            error={error}
          />
          <PfarRemarks
            title="Remark Details"
            name="recommendation" // just a field name, not value!
            defaultValue={dataRecommendation}
            extraLabel="Remarks"
            setDeveloperRemarks={setDeveloperRemarks}
            developerRemarks={developerRemarks}
            type="remarkDetails"
            buttonshow={true}
            onSaveClick={callPfarDetailsAPI} // <-- parent callback
          />
          {/* this has to be changed to PFAR table */}
          <PfarDetailsTable detailData={pFarDetailsData?.DetailDataRemarks} />
        </React.Fragment>
      );
    } else if (activeTab === 6) {
      return (
        <React.Fragment>
          <PrimaryContent formData={formData} handleChange={handleTabChange} serviceName={"Map Submission"} />
          <CollapsibleHistory
            formData={formData}
            callNotingDetailsAPI={callNotingDetailsAPI}
            developerRemarks={developerRemarks}
            setDeveloperRemarks={setDeveloperRemarks}
            notingRemarksData={notingRemarksData}
          />
          {formData?.status === "APPLY_FOR_DSC" && (
            <DscLetters
              formData={formData}
              handleChange={handleTabChange}
              isEmployee={!isCitizen}
              viewDrawing={false}
              pdfType={"FAR"}
              pFARLetter={true}
            />
          )}
          <OnSelectActionDropdown currentAction={currentAction || mapSubmissionAction || " "} onChange={onDropDownSelect} actions={actions} />
          <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
          <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
          {(formData?.IsApprovalCertificate && formData?.IsSanctionDrawing) ||
          formData?.status !== "EE_TP_AFTER_PAYMENT" ||
          formData?.status !== "VC_AFTER_PAYMENT" ? (
            <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />
          ) : (
            <NewsTicker textForNews="Please make a digital sign on sanction letter and approval letter" />
          )}
        </React.Fragment>
      );
    } else if (activeTab === 7) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} />
        </React.Fragment>
      );
    }
  };

  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <EmpTopBar formData={formData} />
      <NewsTicker textForNews="Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly." />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="fullWidth">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          {isCompounding && <PrimaryTab label="Compounding Checklist" />}

          <PrimaryTab label="NOC Status" />
          <PrimaryTab label="Drawing Details" />
          <PrimaryTab label="Site Inspection" />
          <PrimaryTab label="Purchasable FAR" />
          <PrimaryTab label="Take Action" />
          <PrimaryTab label="All Remarks" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            setIsPreviewLoading={setIsPreviewLoading}
            setIframeSrc={setIframeSrc}
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {activeTab === 1 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedDocTab}
            onChange={(e, i) => handleSubDocTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabDocLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {/* {activeTab === 2 && (        <SubTabsWrapper>          <SubTabs            value={selectedNocTab}            onChange={(e, i) => handleSubNocTabChange(i)}            aria-label="Sub Tab Group"            variant="scrollable"            scrollButtons="auto"          >            {subTabNocLabels.map((tab, index) => (              <SubTab key={index} label={tab.label} />            ))}          </SubTabs>        </SubTabsWrapper>      )} */}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default EmpMapPurchasablePortal;
